export enum OrganizationStatus {
    None = 0,
    PendingOfDocument = 1,
    CompletedDocumentation = 2,
    Approved = 3
}
